import { $, $all, on, forEach, addClass, removeClass } from "@olmokit/dom";
import { getUrlQueryParams } from "@olmokit/utils/getUrlQueryParams";
import { updateUrlQueryParams } from "@olmokit/utils/updateUrlQueryParams";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import gsap from "gsap";
gsap.registerPlugin(ScrollToPlugin);

const acc = $all(".step");

/**
 * Component: Checkout
 */
export function Checkout() {
    console.log("Checkout mounted.");

    const $checkoutAddressesShipping = $('.CheckoutAddresses:shipping');
    const $checkoutAddressesBilling = $('.CheckoutAddresses:billing_shipping');

    const getParams = getUrlQueryParams();
    if(getParams['step'] == '0') {
        activeStep(0);
    } else if (getParams['step'] == '1') {
        activeStep(1);
    } else if (getParams['step'] == '2') {
        activeStep(2);
        if(getParams['type'] == 'retire'){
            addClass($checkoutAddressesShipping, 'noAddressShipping');
            addClass($checkoutAddressesBilling, 'noAddressShipping');
        } else {
            removeClass($checkoutAddressesShipping, 'noAddressShipping');
            removeClass($checkoutAddressesBilling, 'noAddressShipping');
        }
    } else if (getParams['step'] == '3') {
        activeStep(3);
    }

}

export function activeStepOnclick(num) {
    // $('.active').nextElementSibling.style.display = "none";
    // removeClass($('.active').nextElementSibling, 'activeStep');
    // removeClass($('.active'), 'active');
    addClass(acc[num], 'active');

    addClass(acc[num], 'active');
    // acc[num].nextElementSibling.style.display = "block";    
    addClass(acc[num].nextElementSibling, 'activeStep');
}

export function activeStep(num) {
    addClass(acc[num], 'active');
    // acc[num].nextElementSibling.style.display = "block";
    addClass(acc[num].nextElementSibling, 'activeStep');
    gsap.to(window, { duration: 0.3, scrollTo: { y: acc[num], offsetY: 90 } });
}

export function updateStepparams(num) {
    const currentUrl = window.location.href;
    window.history.replaceState({}, "", `${updateUrlQueryParams(currentUrl, num)}`);
}

export function updateStepparamsRetire() {
    let url = window.location.href;
    let urlUrl = new URL(url);
    let params = new URLSearchParams(urlUrl.search.slice(1));

    params.set('type', 'retire');
    window.history.replaceState({}, "", `${location.pathname}?${params}`);    
}

export function getUrlParamGuest() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const token = urlParams.get('token')
    return token;
}

export function deleteStepparamsRetire() {
    let url = window.location.href;
    let urlUrl = new URL(url);
    let params = new URLSearchParams(urlUrl.search.slice(1));

    params.delete('type');    
    window.history.replaceState({}, "", `${location.pathname}?${params}`);    
}